var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { useFormState } from "./use-form-state";
import { useEntityFormQuery } from "./use-entity-form-query";
import { entityTypeNameFor } from "@shapeable/utils";
import { useEntityMutation } from "./use-entity-mutation";
import { useManagement } from "./use-management";
import React from "react";
import { compact, keyBy, mapValues } from "lodash";
import { entityFormFieldExtract } from "../utils/entity-form-field-extract";
export var useEntityForm = function (options) {
  var _a;
  var entity = options.entity,
    type = options.type,
    _b = options.fields,
    fields = _b === void 0 ? [] : _b;
  var formName = entity.path;
  var entityTypeName = entityTypeNameFor(entity);
  var formState = useFormState(formName);
  var management = useManagement();
  var result = useEntityFormQuery({
    entityTypeName: entityTypeName,
    type: type,
    id: entity.id,
    fields: fields
  });
  var formEntity = result.data;
  var fieldsToUse = (fields.length ? fields : (_a = result.entityTypeDefinition) === null || _a === void 0 ? void 0 : _a.fields) || [];
  var mutation = useEntityMutation({
    entityTypeName: entityTypeName,
    type: type,
    id: entity.id,
    fields: fieldsToUse
  });
  var autoFocusUsed = false;
  var formFields = compact(fieldsToUse.map(function (fieldSpec, index) {
    var _a;
    /* @ts-ignore */
    if (fieldSpec.type === 'custom') {
      return null; // these fields should not come through
    }
    var autoFocus = false;
    if (!autoFocusUsed && fieldSpec.formFieldType !== 'hidden') {
      autoFocus = true;
      autoFocusUsed = true;
    }
    var field = {
      autoFocus: autoFocus,
      type: fieldSpec.formFieldType || 'hidden',
      name: fieldSpec.name,
      entityTypeDefinition: result.entityTypeDefinition,
      supportingEntityTypeDefinitions: result.supportingEntityTypeDefinitions,
      data: ((_a = result === null || result === void 0 ? void 0 : result.fieldData) === null || _a === void 0 ? void 0 : _a[fieldSpec.name]) || {},
      label: fieldSpec.label,
      description: (management.isOwn ? fieldSpec.ownDescription || fieldSpec.description : fieldSpec.description) || '',
      required: fieldSpec.required
    };
    return field;
  }));
  // for any linked entities, we need to load in the options for the select fields
  // --- SET INITIAL STATE of FORM
  React.useEffect(function () {
    if (formEntity) {
      var formFieldsByName = keyBy(formFields, 'name');
      var formFieldsState = formEntity ? mapValues(formFieldsByName, function (field) {
        var _a;
        return {
          value: ((_a = result === null || result === void 0 ? void 0 : result.fieldValues) === null || _a === void 0 ? void 0 : _a[field.name]) || entityFormFieldExtract(formEntity[field.name], field) || '',
          mutationValue: entityFormFieldExtract(formEntity[field.name], field) || '',
          isValid: true
        };
      }) : {};
      formState.patchFields(formFieldsState);
    }
  }, [formEntity]);
  var submit = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, mutation.submit({
          variables: {
            id: entity.id,
            input: __assign({
              name: entity.name || (formEntity === null || formEntity === void 0 ? void 0 : formEntity.name)
            }, formState.mutationValue)
          }
        })];
      });
    });
  };
  var isLoading = !formEntity || mutation.loading;
  var isSubmitting = mutation.loading;
  var disabledActions = compact([isLoading && 'save', isSubmitting && 'cancel']);
  var loadingActions = compact([isSubmitting && 'save']);
  return {
    isLoading: isLoading,
    disabledActions: disabledActions,
    loadingActions: loadingActions,
    entityTypeDefinition: result.entityTypeDefinition,
    supportingEntityTypeDefinitions: result.supportingEntityTypeDefinitions,
    isReady: type === 'Update' ? !!formEntity : !!result.entityTypeDefinition,
    isSubmitting: mutation.loading,
    submit: submit,
    name: formName,
    fields: formFields,
    state: formState,
    mutation: mutation
  };
};